import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";

export const projectManagementRouter: RouteRecordRaw[] = [
    {
        path: "projectManagement",
        name: "ProjectManagement",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "项目管理"
        },
        redirect: "/projectManagement/index",
        children: [
            {
                path: "index",
                name: "Project",
                component: () => import("@/views/pages/projectManagement/project/index.vue"),
                meta: {
                    title: "项目管理",
                    pageType: PAGE_TYPE.LIST.code,
                    // activeMenu: "ProjectManagement",
                    // hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_PROJECT_BUY_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "project/add",
                name: "ProjectAdd",
                component: () => import("@/views/pages/projectManagement/project/add/index.vue"),
                meta: {
                    title: "新增项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "Project",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project/edit/:id",
                name: "ProjectEdit",
                component: () => import("@/views/pages/projectManagement/project/add/index.vue"),
                meta: {
                    title: "修改项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "Project",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project/detail/:id",
                name: "ProjectInfo",
                component: () => import("@/views/pages/projectManagement/project/info/index.vue"),
                meta: {
                    title: "项目详情",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "Project",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_PROJECT_BUY_MANAGE"
                        }
                    ],
                    isNotShowHeader: true
                }
            },
            {
                path: "project-inception",
                name: "ProjectInception",
                component: () => import("@/views/pages/projectManagement/projectInception/index.vue"),
                meta: {
                    title: "项目期初",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project-inception/add",
                name: "ProjectInceptionAdd",
                component: () => import("@/views/pages/projectManagement/projectInception/add.vue"),
                meta: {
                    title: "新增项目期初",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "ProjectInception",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project-inception/edit/:id",
                name: "ProjectInceptionEdit",
                component: () => import("@/views/pages/projectManagement/projectInception/add.vue"),
                meta: {
                    title: "修改项目期初",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "ProjectInception",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "project-inception/:id",
                name: "ProjectInceptionInfo",
                component: () => import("@/views/pages/projectManagement/projectInception/detail.vue"),
                meta: {
                    title: "项目期初详情",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "ProjectInception",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];
